<template>
    <div class="page-container">
        <el-card shadow="never" class="main-card">
            <!-- 操作按钮 -->
            <div class="search-bar">
                <el-button type="primary" plain :icon="CirclePlusFilled" @click="handler.addHandler">新增</el-button>
                <el-button type="danger" plain :icon="Delete" @click="handler.deleteBatchHandler">删除</el-button>
            </div>

            <!-- 表格区 -->
            <div class="table-wrapper">
                <el-table :data="tableData" v-loading="tableLoading" height="100%" row-key="id"
                    default-expand-all :filter-node-method="handler.treeFilter" ref="dataTableRef"
                    class="modern-table"
                    :header-cell-style="{ background: '#fafafa', color: '#909399', fontWeight: 500 }">
                    <el-table-column type="selection" width="40" />
                    <el-table-column prop="orgName" label="机构名" />
                    <el-table-column prop="modifyName" label="修改人" width="130" />
                    <el-table-column prop="modifyDate" label="修改日期" width="170"/>
                    <el-table-column label="操作" width="110" fixed="right" header-align="center">
                        <template #default="scope">
                            <el-button size="small" circle :icon="Edit" @click="handler.editHandler(scope.row)" />
                            <el-button size="small" circle type="danger" :icon="Delete" @click="handler.deleteHandler(scope.row)" />
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-card>

        <el-dialog v-model="dialogFormVisible" title="新建/编辑" width="700" append-to-body="true">
            <el-form :inline="true" :model="form" :label-position="top" label-width="auto" :rules="rules" status-icon
                ref="dataFormRef">
                <el-form-item v-show="false" label="id" prop="id">
                    <el-input v-model="form.id"></el-input>
                </el-form-item>
                <el-form-item label="机构名" prop="orgName">
                    <el-input v-model="form.orgName" autocomplete="off" class="el-input-width" />
                </el-form-item>
                <el-form-item label="上级机构" prop="parentId">
                    <el-tree-select v-model="form.parentId" :data="tableData" :props="{ label: 'orgName', value: 'id' }"
                        check-strictly :render-after-expand="false" default-expand-all="true" class="el-input-width"
                        placeholder="请选择所属机构" />
                </el-form-item>
            </el-form>
            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="dialogFormVisible = false">取消</el-button>
                    <el-button type="primary" @click="handler.saveHandler">保存</el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<style lang="css" scoped>
@import "../../../src/assets/styles/common.css";
</style>

<script setup>
import { nextTick, ref, reactive, onMounted } from "vue";
import "@/assets/styles/crud-page.css";
import { ElTable, ElMessageBox, ElMessage } from "element-plus";
import { Delete, CirclePlusFilled, Edit } from "@element-plus/icons-vue";
import "element-plus/dist/index.css";
import { orgApi } from "@/api/org-api.js";

//状态标志
const dialogFormVisible = ref(false);
const tableLoading = ref(false);

//数据
const tableData = ref([]);

//引用
const dataTableRef = ref(null);
const dataFormRef = ref(null);

//查询条件
const queryCon = reactive({ orgName: "" });

//表单对象
const form = reactive({
    id: "",
    parentId: null,
    orgName: "",
    orgType: 1,
});
const resetForm = () => {
    dataFormRef.value?.resetFields();
};
const rules = {
    orgName: [{ required: true, message: "机构名称不能为空", trigger: "blur" }],
    parentId: [{ required: true, message: "请选择上级机构", trigger: "blur" }],
};
//生命周期
onMounted(async () => {
    handler.queryHandler();
});

//UI界面逻辑
const handler = {
    queryHandler() {
        tableLoading.value = true;
        orgApi.getOrgTree(queryCon)
            .then((response) => {
                if (response.data.errorCode === "00000") {
                    tableData.value = response.data.result;
                } else {
                    ElMessage.error(
                        `操作失败，${response.data.errorMessage}, [错误码:${response.data.errorCode}]`
                    );
                }
            })
            .finally(function () {
                tableLoading.value = false;
            });
    },
    treeFilter() {
        return tableData.value.orgName.includes(queryCon.orgName);
    },
    addHandler() {
        resetForm();
        dialogFormVisible.value = true;
    },
    editHandler(rowObj) {
        resetForm();
        dialogFormVisible.value = true;
        nextTick(() => {
            Object.assign(form, rowObj);
        });
    },
    deleteHandler(rowObj) {
        ElMessageBox.confirm("确认要删除吗?", "删除确认", {
            confirmButtonText: "确认",
            cancelButtonText: "取消",
            type: "warning",
        }).then(() => {
            orgApi.deleteOrg([rowObj.id]).then((response) => {
                if (response.data.errorCode === "00000") {
                    ElMessage({ message: "删除成功.", type: "success" });
                    handler.queryHandler();
                } else {
                    ElMessage.error(
                        `操作失败，${response.data.errorMessage}, [错误码:${response.data.errorCode}]`
                    );
                }
            });
        }).catch(() => {});
    },
    deleteBatchHandler() {
        var selectedRows = dataTableRef.value.getSelectionRows();
        if (selectedRows && selectedRows.length == 0) {
            ElMessage("没有选中任何行");
            return;
        }

        var ids = [];
        selectedRows.forEach(function (item) {
            ids.push(item.id);
        });

        ElMessageBox.confirm("确认要删除吗?", "删除确认", {
            confirmButtonText: "确认",
            cancelButtonText: "取消",
            type: "warning",
        }).then(() => {
            orgApi.deleteOrg(ids).then((response) => {
                if (response.data.errorCode === "00000") {
                    ElMessage({ message: "删除成功.", type: "success" });
                    handler.queryHandler();
                } else {
                    ElMessage.error(
                        `操作失败，${response.data.errorMessage}, [错误码:${response.data.errorCode}]`
                    );
                }
            });
        }).catch(() => {});
    },
    saveHandler() {
        dataFormRef.value.validate((valid) => {
            if (valid) {
                orgApi.saveOrg(form).then((response) => {
                    if (response.data.errorCode === "00000") {
                        ElMessage({ message: "保存成功", type: "success" });
                        handler.queryHandler();
                        dialogFormVisible.value = false;
                    } else {
                        ElMessage.error(
                            `操作失败，${response.data.errorMessage}, [错误码:${response.data.errorCode}]`
                        );
                    }
                });
            }
        });
    }
};
</script>
